import React from 'react';
import PropTypes from 'prop-types';
import Label from 'app/commonComponents/atoms/label';
import Field from 'app/commonComponents/atoms/input';
import { connect } from 'formik';
import { getFieldErrorMessage } from 'app/formComponents/formComponentsUtils';

const TextInput = ({
  formik: { errors, touched },
  name,
  labelText,
  formInputClassName = '',
  labelClassName,
  children,
  ...fieldProps
}) => {
  const errorMessage = getFieldErrorMessage({ errors, touched }, name);
  return (
    <div className={`form-input ${formInputClassName}`}>
      <Label className={`form-input__label ${labelClassName}`} htmlFor={name}>
        {labelText}
      </Label>
      <Field className="form-input__input" type="text" id={name} name={name} {...fieldProps} />
      {errorMessage && <span className="form-msg-error">{errorMessage}</span>}
      {children}
    </div>
  );
};

TextInput.defaultProps = {
  children: null,
  labelClassName: '',
};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  labelClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default connect(TextInput);
